import {
  CUSTOMER_ACCOUNT_TYPES,
  ICONS_WEB,
  PERMISSIONS,
  VENDOR_ACCOUNT_TYPES,
} from "@miplatform/constants";
import { AccountType } from "@miplatform/types";

export const BUILDER = "builder";
export const SERVICE = "service";
export const SUBCONTRACTOR = "subcontractor";
export const SUPPLIER = "supplier";

export const ACCOUNTS_TAB_TO_TYPE = {
  [BUILDER]: AccountType.Builder,
  [SERVICE]: AccountType.Service,
  [SUBCONTRACTOR]: AccountType.Subcontractor,
  [SUPPLIER]: AccountType.Supplier,
};

export const ACCOUNTS_TAB_TO_PERMISSIONS = {
  [BUILDER]: PERMISSIONS.BUILDER,
  [SERVICE]: PERMISSIONS.SERVICE_CUSTOMER,
  [SUBCONTRACTOR]: PERMISSIONS.SUBCONTRACTOR,
  [SUPPLIER]: PERMISSIONS.SUPPLIER,
};

export const ACCOUNT_PAGE_TYPE = {
  CUSTOMER: "CUSTOMER",
  VENDOR: "VENDOR",
};

export const CUSTOMER_OPTIONS = Object.values(CUSTOMER_ACCOUNT_TYPES).map(
  (type) => ({ label: type, value: type })
);

export const VENDOR_OPTIONS = Object.values(VENDOR_ACCOUNT_TYPES).map(
  (type) => ({ label: type, value: type })
);

export const CUSTOMER_TABS = [
  { label: "Builder", value: BUILDER },
  { label: "Service", value: SERVICE },
];

export const VENDOR_TABS = [
  { label: "Subcontractor", value: SUBCONTRACTOR },
  { label: "Supplier", value: SUPPLIER },
];

export const ACCOUNT_PAGE_CONFIG = {
  [ACCOUNT_PAGE_TYPE.CUSTOMER]: {
    single: "Customer",
    plural: "Customers",
    path: "customers",
    tabs: CUSTOMER_TABS,
    options: CUSTOMER_OPTIONS,
    icon: ICONS_WEB.ACCOUNT_HARDHAT_OUTLINE,
  },
  [ACCOUNT_PAGE_TYPE.VENDOR]: {
    single: "Vendor",
    plural: "Vendors",
    path: "vendors",
    tabs: VENDOR_TABS,
    options: VENDOR_OPTIONS,
    icon: ICONS_WEB.TRUCK,
  },
};

export const isVendorAccountType = (type) =>
  VENDOR_ACCOUNT_TYPES.includes(type);
